<div class="header">
  <button
    mat-icon-button
    type="button"
    class="nav"
    [class.is-hidden]="view() === 'months'"
    [disabled]="previousDisabled()"
    [attr.aria-label]="previousLabel()"
    (click)="step(-1)"
  >
    <mat-icon>chevron_left</mat-icon>
  </button>
  <div class="periods">
    <button
      mat-button
      type="button"
      class="period"
      [attr.aria-expanded]="view() === 'months'"
      (click)="toggle('months')"
    >
      {{ monthName() }}
      <mat-icon iconPositionEnd>{{ view() === 'months' ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
    </button>
    <button mat-button type="button" class="period" [attr.aria-expanded]="view() === 'years'" (click)="toggle('years')">
      {{ visibleYear() }}
      <mat-icon iconPositionEnd>{{ view() === 'years' ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
    </button>
  </div>
  <button
    mat-icon-button
    type="button"
    class="nav"
    [class.is-hidden]="view() === 'months'"
    [disabled]="nextDisabled()"
    [attr.aria-label]="nextLabel()"
    (click)="step(1)"
  >
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>

@switch (view()) {
  @case ('days') {
    <div class="weekdays" aria-hidden="true">
      @for (weekday of weekdays; track weekday) {
        <span>{{ weekday }}</span>
      }
    </div>
    <div class="days">
      @for (cell of days(); track cell.label) {
        @if (cell.inMonth) {
          <button
            type="button"
            class="cell day"
            [class.is-current]="cell.current"
            [disabled]="cell.disabled"
            [attr.aria-label]="cell.label"
            [attr.aria-pressed]="cell.selected"
            [attr.aria-current]="cell.current ? 'date' : null"
            [attr.data-active]="cell === activeDay() ? '' : null"
            [attr.cdkFocusInitial]="cell === activeDay() ? '' : null"
            (click)="pickDay(cell)"
          >
            {{ cell.day }}
          </button>
        } @else {
          <span class="cell day is-outside" aria-hidden="true">{{ cell.day }}</span>
        }
      }
    </div>
  }
  @case ('months') {
    <div class="periods-grid months">
      @for (cell of months(); track cell.value) {
        <button
          type="button"
          class="cell period-cell"
          [class.is-current]="cell.current"
          [disabled]="cell.disabled"
          [attr.aria-label]="cell.label"
          [attr.aria-pressed]="cell.selected"
          [attr.aria-current]="cell.current ? 'date' : null"
          [attr.data-active]="cell === activeMonth() ? '' : null"
          [attr.cdkFocusInitial]="cell === activeMonth() ? '' : null"
          (click)="pickMonth(cell.value)"
        >
          {{ cell.text }}
        </button>
      }
    </div>
  }
  @default {
    <!-- years -->
    <div class="periods-grid years">
      @for (cell of years(); track cell.value) {
        <button
          type="button"
          class="cell period-cell"
          [class.is-current]="cell.current"
          [disabled]="cell.disabled"
          [attr.aria-label]="cell.label"
          [attr.aria-pressed]="cell.selected"
          [attr.aria-current]="cell.current ? 'date' : null"
          [attr.data-active]="cell === activeYear() ? '' : null"
          [attr.cdkFocusInitial]="cell === activeYear() ? '' : null"
          (click)="pickYear(cell.value)"
        >
          {{ cell.text }}
        </button>
      }
    </div>
  }
}
